import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  MODE,
  OPTIONS,
  QUESTION_CARD_STRINGS,
} from '../../constants/app-strings.constants';
import { Question } from '../../models/question.model';
import { TestService } from 'src/app/core/services/test.service';
import { parseQuestionContent, StatementPart } from '../../utils/parse-question-content';

@Component({
  selector: 'app-question-card',
  templateUrl: './question-card.component.html',
  styleUrl: './question-card.component.scss',
})
export class QuestionCardComponent implements OnInit, OnChanges {
  @Input() question: Question | undefined;
  @Input() mode: string | undefined;
  @Input() index: number = 0;
  @Input() isActionAllowed: boolean = true;
  @Input() isInLibrary: boolean = false;
  @Input() candidateAnswer?: string[];
  @Output() deleteQuestionFromLibrary$ = new EventEmitter<Question>();
  @Output() openQuestionForm$ = new EventEmitter<void>();
  @Output() deleteQuestionFromBulkAdd$ = new EventEmitter<Question>();
  OPTIONS = OPTIONS;
  QUESTION_CARD_STRINGS = QUESTION_CARD_STRINGS;
  MODE = MODE;
  isAnsweredQuestion: boolean = false;
  statementParts: StatementPart[] = [];
  optionParts: StatementPart[][] = [[], [], [], []];

  constructor(private testService: TestService) {}

  ngOnInit(): void {
    this.refreshContentParts();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question'] || changes['candidateAnswer']) {
      this.refreshContentParts();
    }
  }

  private refreshContentParts(): void {
    this.isAnsweredQuestion = !!this.candidateAnswer;
    this.statementParts = parseQuestionContent(this.question?.PROBLEM_STATEMENT);
    this.optionParts = [
      parseQuestionContent(this.question?.OPTION_1),
      parseQuestionContent(this.question?.OPTION_2),
      parseQuestionContent(this.question?.OPTION_3),
      parseQuestionContent(this.question?.OPTION_4),
    ];
  }

  addQuestionToTestPool(): void {
    this.testService.addQuestionToTestPool$.emit(this.question);
  }

  deleteQuestionFromTestPool(): void {
    this.testService.deleteQuestionfromTestPool$.emit(this.question);
  }

  deleteQuestionFromLibrary(): void {
    this.deleteQuestionFromLibrary$.emit(this.question);
  }

  deleteQuestionFromBulkAdd(): void {
    this.deleteQuestionFromBulkAdd$.emit(this.question);
  }

  openQuestionForm(): void {
    this.openQuestionForm$.emit();
  }
}
